import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';
import commonFields from '../helpers/commonFields';
import buttonFields from '../helpers/buttonFields';

const GMKorisnici: IModel = {
  title: 'Korisnici',
  apiPath: 'groblja/osobe/{id}/grobna-mjesta',
  forms: {
    default: {
      fields: [
        'osoba_id',
        'grobno_mjesto_id',
        'groblje_id',
        'uloga',
        'naknada',
        'osnova_stjecanja_prava_koristenja',
        'redni_broj',
        'datum_upisa',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
      ],
      layout: [
        {
          title: 'groblja:sections.podaci_o_korisniku',
          columns: 2,
          fieldNames: [
            'osoba_id',
            'uloga',
            'groblje_id',
            'grobno_mjesto_id',
            'naknada',
            'osnova_stjecanja_prava_koristenja',
            'redni_broj',
            'datum_upisa',
          ],
        },
        {
          title: 'groblja:sections.knjiga_ocevidnika',
          columns: 3,
          fieldNames: ['ocevidnik_knjiga_broj', 'ocevidnik_knjiga_strana', 'ocevidnik_knjiga_redni_broj'],
        },
        {
          title: 'groblja:sections.pomocna_knjiga',
          columns: 3,
          fieldNames: ['ocevidnik_pomocna_knjiga_broj', 'ocevidnik_pomocna_knjiga_strana', 'ocevidnik_pomocna_knjiga_redni_broj'],
        },
        {
          title: 'common.ostalo',
          columns: 1,
          fieldNames: ['napomena'],
        },
      ],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'groblje_id',
        'grobno_mjesto_id',
        'uloga',
        'naknada',
        'osnova_stjecanja_prava_koristenja',
        'redni_broj',
        'datum_upisa',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'docs',
        'btn_show_history',
      ],
      hidden: [
        'id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
      ],
    },
    korisnici_grobno_mjesto: {
      fields: [
        'id',
        'groblje_id',
        'grobno_mjesto_id',
        'gm_external_id',
        'uloga',
        'naknada',
        'osnova_stjecanja_prava_koristenja',
        'redni_broj',
        'datum_upisa',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'docs',
        'btn_show_history',
      ],
      hidden: [
        'id',
        'gm_external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
      ],
    },
    korisnici_grobno_mjesto_history: {
      fields: [
        'id',
        'groblje_id',
        'grobno_mjesto_id',
        'gm_external_id',
        'uloga',
        'naknada',
        'osnova_stjecanja_prava_koristenja',
        'redni_broj',
        'datum_upisa',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'docs',
        'edited'
      ],
      hidden: [
        'id',
        'gm_external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
      ],
    },
    grobno_mjesto_korisnici: {
      fields: [
        'id',
        'oib',
        'ime',
        'prezime',
        'kontakt',
        'o_external_id',
        'uloga',
        'naknada',
        'osnova_stjecanja_prava_koristenja',
        'redni_broj',
        'datum_upisa',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'docs',
        'btn_show_history',
      ],
      hidden: [
        'id',
        'o_external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
      ],
    },
    grobno_mjesto_korisnici_history: {
      fields: [
        'id',
        'oib',
        'ime',
        'prezime',
        'kontakt',
        'o_external_id',
        'uloga',
        'naknada',
        'osnova_stjecanja_prava_koristenja',
        'redni_broj',
        'datum_upisa',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'docs',
        'btn_show_history',
        'edited'
      ],
      hidden: [
        'id',
        'o_external_id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
      ],
    },
  },
  fields: [
    coreFields.id,
    commonFields.docsHistory,
    buttonFields.show_history,
    {
      title: 'oib',
      source: 'oib',
      ttoken: 'common.oib',
      type: 'text',
      filter: true,
    },
    {
      type: 'boolean',
      source: 'has_history',
      title: 'has history',
      ttoken: 'common.has_history',
    },
    {
      title: 'ime',
      source: 'ime',
      ttoken: 'common.ime',
      type: 'text',
      filter: true,
    },

    {
      title: 'prezime',
      source: 'prezime',
      ttoken: 'common.prezime',
      type: 'text',
      filter: true,
    },

    {
      title: 'ime_prezime',
      source: 'ime_prezime',
      ttoken: 'common.ime_prezime',
      type: 'text',
      filter: true,
    },
    {
      title: 'kontakt',
      source: 'kontakt',
      ttoken: 'common.kontakt',
      type: 'text',
      filter: true,
      width: 'full'
    },
    {
      title: 'grobno_mjesto_id',
      source: 'grobno_mjesto_id',
      ttoken: 'groblja:grobna_mjesta.grobno_mjesto',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/grobna-mjesta?view=picker',
        format: '{label}',
        idattr: 'id',
        additionalData: ['groblje_id'],
      },
      validation: {
        required: true,
      },
    },
    {
      title: 'osoba_id',
      source: 'osoba_id',
      ttoken: 'groblja:korisnici.korisnik_id',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/osobe?view=picker',
        idattr: 'id',
        format: '{label}',
      },
      filter: true,
      validation: {
        required: true,
      },
    },
    {
      title: 'uloga',
      source: 'uloga',
      ttoken: 'groblja:korisnici.uloga',
      type: 'picker',
      items: {
        labels: ['OBVEZNIK', 'PRAVO UKOPA'],
        values: ['OBVEZNIK', 'PRAVO UKOPA'],
      },
      filter: true,
      validation: {
        required: true,
      },
    },

    {
      title: 'naknada',
      source: 'naknada',
      ttoken: 'groblja:korisnici.naknada',
      type: 'numeric',
      filter: true,
    },

    {
      title: 'osnova_stjecanja_prava_koristenja',
      source: 'osnova_stjecanja_prava_koristenja',
      ttoken: 'groblja:korisnici.osnova_stjecanja',
      type: 'text',
      filter: true,
      width: 'full',
    },

    {
      title: 'redni_broj',
      source: 'redni_broj',
      ttoken: 'groblja:korisnici.redni_broj',
      type: 'numeric',
      filter: true,
    },

    {
      title: 'datum_upisa',
      source: 'datum_upisa',
      ttoken: 'groblja:korisnici.datum_upisa',
      type: 'date',
      filter: true,
    },
    {
      title: 'external_id',
      source: 'o_external_id',
      ttoken: 'common.external_id',
      type: 'text',
      filter: true,
    },
    {
      title: 'external_id',
      source: 'gm_external_id',
      ttoken: 'common.external_id',
      type: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_broj',
      source: 'ocevidnik_knjiga_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_strana',
      source: 'ocevidnik_knjiga_strana',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_strana',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_redni_broj',
      source: 'ocevidnik_knjiga_redni_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_redni_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_broj',
      source: 'ocevidnik_pomocna_knjiga_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_strana',
      source: 'ocevidnik_pomocna_knjiga_strana',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_strana',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_redni_broj',
      source: 'ocevidnik_pomocna_knjiga_redni_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_redni_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'napomena',
      source: 'napomena',
      ttoken: 'common.napomena',
      type: 'multiline',
      rows: 3,
      maxRows: 10,
      width: 'full',
      filter: true,
    },
    {
      title: 'is_deleted',
      source: 'is_deleted',
      ttoken: '',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'edited',
      source: 'edited',
      ttoken: 'common.edited',
      type: 'datetime',
      filter: true,
    },
    {
      title: 'action',
      source: 'action',
      ttoken: 'common.action',
      type: 'picker',
      items: {
        labels: ['common.actions.update', 'common.actions.insert', 'common.actions.delete'],
        values: ['UPDATE', 'INSERT', 'DELETE'],
      },
      filter: true,
      translate: true,
      readonly: true,
    },
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
      filter: true,
    },
    coreFields.geom,
    coreFields.created_by,
    coreFields.gid,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
  ],
};

export default GMKorisnici;
